import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToMessageV1 from 'utils/converters/backend/fromAnyToMessageV1.util';
import fromStatusToMessageV1 from 'utils/converters/backend/fromStatusToMessageV1.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

const L = logger('fromActionToMessage');

const fromActionToMessage = (action) => {
  if (!action) {
    L.debug('()', 'No action:', action);
    return '';
  }

  const { error, status } = asObject(action);
  if (!error && status >= 200 && status < 300) {
    L.debug('()', 'No error:', error, 'or invalid status:', status);
    return '';
  }

  const result = fromAnyToTrimmed(fromAnyToMessageV1(error)) || fromAnyToTrimmed(fromStatusToMessageV1(status));
  L.debug('()', 'result:', result);

  return result;
};

export default fromActionToMessage;
